import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEpg$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEpg extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fea19bbba535708b5ff9cd54ad6570ecb9d4f2e7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '46bd659fda8a8505fa4b8829d6e1403b599b380d', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7fb1ee0f8f38fb85ca0a4edeb41c8ae0b266bb01', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3 4.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-14A.5.5 0 0 1 3 5zm14.21 10.6 2.52 2.52a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0l-2.52-2.52a4.53 4.53 0 1 1 1.06-1.06m-6.66-2.6a3 3 0 1 0 6 0 3 3 0 0 0-6 0M3.5 9.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5zm0 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V15a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-epg", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-epg"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-epg":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEpg$1);
            }
            break;
    } });
}

const CosmosIconEpg = CosmosIconEpg$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEpg, defineCustomElement };
